module.exports = __webpack_public_path__ + "static/media/total-fitout.b53c56a5.png";